/* eslint-disable */
import * as Types from '../../../../shared/__gql-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetArtistQueryVariables = Types.Exact<{
  id: Types.Scalars['String'];
}>;


export type GetArtistQuery = { __typename: 'Query', getArtist: { __typename: 'Artist', id: string | null, name: string | null, label_id: string | null, facebook_id: string | null, opus_id: string | null, spotify_url: string | null, gps_status: string | null, gcdm_info: { __typename: 'GcdmInfo', company: string | null, country: string | null, genre: string | null } | null, campaigns: Array<{ __typename: 'Campaign', id: string | null, name: string | null, label_id: string | null }> | null, products: Array<{ __typename: 'GlobalProduct', id: string | null, name: string | null, configuration: string | null, gps_status: string | null, locals: Array<{ __typename: 'LocalProduct', id: string | null, label_id: string | null, campaign_id: string | null } | null> | null }> | null } | null };


export const GetArtistDocument = gql`
    query getArtist($id: String!) {
  getArtist(id: $id) {
    id
    name
    label_id
    facebook_id
    gcdm_info {
      company
      country
      genre
    }
    opus_id
    spotify_url
    gps_status
    campaigns {
      id
      name
      label_id
    }
    products {
      id
      name
      configuration
      gps_status
      locals {
        id
        label_id
        campaign_id
      }
    }
  }
}
    `;

/**
 * __useGetArtistQuery__
 *
 * To run a query within a React component, call `useGetArtistQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArtistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArtistQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetArtistQuery(baseOptions: Apollo.QueryHookOptions<GetArtistQuery, GetArtistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetArtistQuery, GetArtistQueryVariables>(GetArtistDocument, options);
      }
export function useGetArtistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetArtistQuery, GetArtistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetArtistQuery, GetArtistQueryVariables>(GetArtistDocument, options);
        }
export type GetArtistQueryHookResult = ReturnType<typeof useGetArtistQuery>;
export type GetArtistLazyQueryHookResult = ReturnType<typeof useGetArtistLazyQuery>;